import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {Observable} from "rxjs";
import {RaceService,} from "@services";
import {inject} from "@angular/core";
import {ResolveFn, RouterStateSnapshot} from "@angular/router";
import {ListSortOrder, PagedFilter, Pages, RaceRegistration, RegistrationFilter} from "@model";

export const EventRegistrationsResolver: ResolveFn<Observable<RaceRegistration[]> |
  Promise<RaceRegistration[]> | RaceRegistration[]> | any =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router,
   raceService: RaceService = inject(RaceService))
    : Observable<RaceRegistration[]> |
    Promise<RaceRegistration[]> | RaceRegistration[] | any => {

    if (route.queryParams['eventId']) {
      let pagedFilter:PagedFilter<RegistrationFilter> = new PagedFilter(new Pages(), new RegistrationFilter(undefined, undefined, +route.queryParams['eventId'], undefined),
        ListSortOrder.DESC);
      return raceService.findMatchingRegistrations(pagedFilter);
    } else {
      return [];
    }
  }


